import React from "react";
import { observer, inject } from "mobx-react";
import Link from "@material-ui/core/Link";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import * as dateFns from "date-fns";

const SurveyResultsResponses = ({ store }) => {
  const { $survey, $respondent, $user } = store;

  return (
    <div className="mt-4  ">
      Aantal inzendingen: {$survey.selected.responsesForSelectedGroup.length}
      <TableContainer component={Paper}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>createdOn</TableCell>
              <TableCell>createdBy</TableCell>
              <TableCell>createdBy (mail)</TableCell>
              <TableCell>groupName</TableCell>
              {$user.sessionUser.isAdmin && <TableCell>action</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {$survey.selected.responsesForSelectedGroup.slice(0, 200).map((row, i) => (
              <TableRow key={"row" + i}>
                <TableCell component="th" scope="row">
                  {dateFns.format(row.createdOn, "dd/MM/yy HH:mm")}
                </TableCell>
                <TableCell>{row.createdBy}</TableCell>
                <TableCell>{row.userEmail}</TableCell>
                <TableCell>{row.groupName}</TableCell>
                {$user.sessionUser.isAdmin && (
                  <TableCell>
                    <Link
                      href="#"
                      onClick={() => {
                        $respondent.list.has(row._key) && $respondent.list.get(row._key).fsDelete();
                      }}
                    >
                      Delete
                    </Link>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default inject("store")(observer(SurveyResultsResponses));
